import { useCallback } from 'react';

import type { createPageEditorPluginAIOptions } from '@atlassian/editor-plugin-ai/ConfluencePrebuilt';

type EditorPluginAIOptions = Parameters<typeof createPageEditorPluginAIOptions>[0];

export const useGetChannelVariables: (
	cloudId: string,
	userId: string,
) => EditorPluginAIOptions['getChannelVariables'] = (cloudId, userId) => {
	return useCallback(
		(purpose) => {
			if (purpose === 'rovo-agent') {
				return {
					contentURL: window.location.origin + window.location.pathname,
					cloudId,
					userId,
				};
			}
			return null;
		},
		[cloudId, userId],
	);
};
